<template>
    <v-card
        class="dashboard-card ma-2"
        elevation="0"
    >
        <v-card-title>Reports</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-form
                ref="reportForm"
                v-model="isValid"
            >
                <v-row>
                    <v-col cols="12">
                        <v-select
                            :disabled="isLoading"
                            :items="reportTypes"
                            item-text="name"
                            item-value="value"
                            label="Report Type"
                            v-model="reportType"
                        ></v-select>
                    </v-col>
                </v-row>
                <v-row v-show="reportType && (reportType.requireFromToDates == true || reportType.requireLiveOrDateRange == true)">
                    <v-col cols="12">
                                                                                        <v-switch v-show="reportType && reportType.requireLiveOrDateRange == true"
                                            class="mb-0"
                                            label="Live"
                                            v-model="isLive"
                                        ></v-switch>
                    </v-col>
                    <v-col cols="6" v-show="!(reportType && reportType.requireLiveOrDateRange == true && this.isLive == true)">
                        <v-menu
                            :close-on-content-click="false"
                            :nudge-right="40"
                            min-width="290px"
                            offset-y
                            transition="scale-transition"
                            v-model="dateMenuFrom"

                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    :disabled="isLoading"
                                    label="From"
                                    prepend-icon="mdi-calendar-month"
                                    readonly
                                    v-bind="attrs"
                                    v-model="inputDateFrom"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                @input="dateMenuFrom = false"
                                color="secondary"
                                v-model="inputDateFrom"
                                
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="6" v-show="!(reportType && reportType.requireLiveOrDateRange == true && this.isLive == true)">
                        <v-menu
                            :close-on-content-click="false"
                            :nudge-right="40"
                            min-width="290px"
                            offset-y
                            transition="scale-transition"
                            v-model="dateMenuTo"
                            
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    :disabled="isLoading"
                                    label="To"
                                    prepend-icon="mdi-calendar-month"
                                    readonly
                                    v-bind="attrs"
                                    v-model="inputDateTo"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                @input="dateMenuTo = false"
                                color="secondary"
                                v-model="inputDateTo"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
                <v-row v-if="reportType && reportType.requireProviderId == true">
                    <v-col cols="12">
                        <v-select
                            :disabled="isLoading"
                            :items="providers"
                            :rules="[requiredRule]"
                            clearable
                            item-text="value"
                            item-value="key"
                            label="Provider"
                            v-model="providerId"
                        ></v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-spacer></v-spacer>
                    <v-btn
                        :disabled="isLoading && !isSaving"
                        :loading="isSaving"
                        @click="getReport"
                        class="text-none"
                        color="secondary darken-1"
                        text
                    >Get</v-btn>
                </v-row>
            </v-form>
        </v-card-text>
        <v-snackbar
            :color="notifyColor"
            :timeout="notifyTimeout"
            top
            v-model="notifyShow"
        >
            {{ notifyMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    @click="notifyShow = false"
                    class="text-none"
                    icon
                    v-bind="attrs"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-card>
</template>

<script>
import fileDownload from "js-file-download";
export default {
    props: ["accessCrud"],
    name: "Reports",
    data: () => ({
        isLoading: null,
        isSaving: null,
        isValid: null,
        inputDateFrom: new Date().toISOString().substr(0, 10),
        inputDateTo: new Date().toISOString().substr(0, 10),
        notifyShow: null,
        notifyMessage: null,
        notifyColor: null,
        notifyTimeout: 15000,

        dateMenuFrom: false,
        dateMenuTo: false,
        providers: [],
        providerId: null,

        isLive: true,

        reportTypes: [],
        reportType: null, // this.reportTypes[0],
        requiredRule: v => !!v || "required"
        //
    }),
    created: function() {
        this.reportTypes = [
/*
            {
                name: "Accounts, New Live",
                entity: "ReportServiceProviderAccess",
                value: {
                    access: "newaccountsreportlive",
                    requireFromToDates: false,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            {
                name: "Claims, Accepted Not Yet Submitted Live",
                entity: "Report",
                value: {
                    access: "acceptednotyetsubmittedclaimsreportlive",
                    requireFromToDates: false,
                    requireLiveOrDateRange: false,
                    requireProviderId: false
                }
            },
            */

            
        ]
            .filter(x => {
                return this.accessCrud.some(y => {
                    return x.entity == y.e && y.c == true;
                });
            })
            .sort(function(a, b) {
                return a.name > b.name ? 1 : -1;
            });
        this.areAnyReportsAvailable(this.reportTypes.length > 0);
    },
    mounted: async function() {
        if (this.reportTypes.length > 0)
            this.reportType = this.reportTypes[0].value;
        //
        this.providers = await this.$store.dispatch("providers/getlist");
    },
    components: {
        //
    },
    methods: {
        areAnyReportsAvailable(areAnyReportsAvailable) {
            this.$emit("reports", areAnyReportsAvailable);
        },
        notify(message, color, timeout) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
            this.notifyTimeout =
                typeof timeout === "undefined" ? 15000 : timeout;
        },
        validateForm() {
            this.isValid = this.$refs.reportForm.validate();
            return this.isValid;
        },
        getReport() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;
                var params = {};

                if (this.reportType.requireFromToDates == true) {
                    params.fromDate = this.inputDateFrom;
                    params.toDate = this.inputDateTo;
                }

                if (this.reportType.requireLiveOrDateRange == true) {
                    params.live = this.isLive;
                    if(this.isLive == false)
                    {
                    params.fromDate = this.inputDateFrom;
                    params.toDate = this.inputDateTo;
                    }
                }

                if (this.reportType.requireProviderId == true) {
                    params.providerId = this.providerId;
                }

                this.$store
                    .dispatch("reports/" + this.reportType.access, params)
                    .then(
                        response => {
                            this.notify("Downloading...", "success", 3000);
                            fileDownload(
                                response.data,
                                response.headers["content-disposition"].match(
                                    /filename\s*=\s*(.+);/i
                                )[1]
                            );
                        },
                        error =>
                            error.response.data
                                .text()
                                .then(text => this.notify(text, "error"))
                    )
                    .finally(this.getReportDone);
            }
        },
        getReportDone() {
            this.isLoading = false;
            this.isSaving = false;
        }
        //
    },
    destroyed: function() {}
};
</script>

<style lang="stylus" scoped></style>